import React from 'react';
import { ActivityIcon } from 'lucide-react';
export function Footer() {
  return <footer className="py-12 px-6 border-t border-white/5 bg-navy-950" data-id="element-70">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-71">
        <div className="flex items-center gap-2" data-id="element-72">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-electric to-mint flex items-center justify-center opacity-80" data-id="element-73">
            <ActivityIcon className="w-3.5 h-3.5 text-navy-950" data-id="element-74" />
          </div>
          <span className="text-slate-300 font-semibold tracking-tight" data-id="element-75">
            Pulsewave
          </span>
        </div>
        <div className="text-sm text-slate-500" data-id="element-76">
          {new Date().getFullYear()} Pulsewave.All rights reserved.
        </div>
      </div>
    </footer>;
}